// Function to initialize project card interactions using event delegation
const initProjectCardInteractions = () => {
  const projectWrapper = document.querySelector(".project-wrapper");
  const blob = document.querySelector(".blob-agence");

  if (!projectWrapper) return;

  projectWrapper.addEventListener("mouseover", (e) => {
    const card = e.target.closest(".project-card");
    if (!card) return;

    const video = card.querySelector(".project-video");
    const hasVideo = card.classList.contains("has-video");
    const allCards = document.querySelectorAll(".project-card");

    // Apply reduced opacity to other cards using GSAP
    allCards.forEach((otherCard) => {
      if (otherCard !== card) {
        gsap.to(otherCard, {
          opacity: 0.4,
          duration: 0.3,
          overwrite: false,
        });
      }
    });

    // Hide blob
    if (blob) {
      gsap.to(blob, {
        opacity: 0,
        duration: 0.3,
        overwrite: false,
      });
    }

    // Play video only if it exists
    if (hasVideo && video) {
      video.currentTime = 0;
      video.play().catch((err) => console.log("Video play failed:", err));
    }
  });

  projectWrapper.addEventListener("mouseout", (e) => {
    const card = e.target.closest(".project-card");
    if (!card) return;

    const video = card.querySelector(".project-video");
    const hasVideo = card.classList.contains("has-video");
    const allCards = document.querySelectorAll(".project-card");

    // Restore opacity to all cards using GSAP
    allCards.forEach((otherCard) => {
      gsap.to(otherCard, {
        opacity: 1,
        duration: 0.3,
        overwrite: false,
      });
    });

    // Show blob
    if (blob) {
      gsap.to(blob, {
        opacity: 1,
        duration: 0.3,
        overwrite: false,
      });
    }

    // Pause video only if it exists
    if (hasVideo && video) {
      video.pause();
      video.currentTime = 0;
    }
  });
};

const projectsAnim = {
  isMobileOrTablet() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || navigator.maxTouchPoints > 2
    );
  },

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const cursor = document.querySelector(".blob-agence");

      /* GSAP ANIMATIONS */
      //Smooth content
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.7,
        effects: false,
      });

      // N'appliquer les effets du curseur que si ce n'est pas un mobile/tablette
      const isMobileOrTablet = this.isMobileOrTablet();
      if (!isMobileOrTablet) {
        // Suivi de la souris avec throttle à 60fps (~16.67ms)
        const root = document.documentElement;
        const smoothContent = document.querySelector("#smooth-content");
        let mx = -9999,
          my = -9999,
          rafId = 0,
          lastUpdateTime = 0;
        const THROTTLE_INTERVAL = 1000 / 60; // ~16.67ms pour 60fps

        function apply() {
          // Mettre à jour le cursor blob avec les coordonnées correctes
          if (cursor) {
            // Récupérer le décalage Y du smooth-content
            const scrollOffset = gsap.getProperty("#smooth-content", "y") || 0;
            gsap.to(cursor, {
              x: mx - 25,
              y: my - 25 - scrollOffset,
              duration: 0,
              overwrite: false,
            });
          }

          rafId = 0;
          lastUpdateTime = performance.now();
        }

        function move(e) {
          // Utilise les coordonnées de la souris par rapport au viewport
          mx = e.clientX;
          my = e.clientY;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        function leave() {
          mx = -9999;
          my = -9999;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        // Écoute sur window pour éviter les problèmes de capture d'événements
        window.addEventListener("pointermove", move, { passive: true });
        window.addEventListener("pointerleave", leave, { passive: true });
      }

      // Initialize project card interactions

      if (!isMobileOrTablet) {
        initProjectCardInteractions();
      }

      /* Project cards load animation */
      if (document.querySelector(".column-odd .project-card")) {
        gsap.from(".column-odd .project-card", {
          y: 100,
          stagger: 0.1,
        });
        gsap.to(".column-odd .project-card", {
          y: 0,
          stagger: 0.5,
        });
      }
      if (document.querySelector(".column-even .project-card")) {
        gsap.from(".column-even .project-card", {
          y: 100,
          stagger: 0.1,
        });
        gsap.to(".column-even .project-card", {
          y: 0,
          stagger: 0.5,
        });
      }

      /* sticky column */
      if (!isMobileOrTablet) {
        gsap.to(".column-filter", {
          scrollTrigger: {
            trigger: ".column-filter",
            start: "-150px 0%",
            /* end: "top center", */
            pin: true,
            markers: false,
            end: "bottom bottom",
          },
          x: 0,
        });
      }

      /* Mobile filter menu sticky with GSAP */

      if (isMobileOrTablet) {
        ScrollTrigger.normalizeScroll(true); // enable

        const mobileFilterBar = document.querySelector(".mobile-filter-bar");
        const pageTopLogo = document.querySelector(".page-top-logo");
        const mobileFilterToggle = document.querySelector(
          ".mobile-filter-toggle",
        );
        const mobileFilterMenu = document.querySelector(".mobile-filter-menu");
        const mobileFilterItems = document.querySelectorAll(
          ".js-filter-item-mobile",
        );

        ScrollTrigger.create({
          trigger: ".mobile-filter-bar",
          start: "top top",
          endTrigger: "#projects",
          end: "bottom top",
          pin: true,
          pinSpacing: false,
          markers: false,
        });

        if (mobileFilterToggle) {
          mobileFilterToggle.addEventListener("click", () => {
            mobileFilterToggle.classList.toggle("active");
            mobileFilterMenu.classList.toggle("open");
          });
        }

        // Close menu when filter item is clicked
        mobileFilterItems.forEach((item) => {
          item.addEventListener("click", () => {
            mobileFilterToggle.classList.remove("active");
            mobileFilterMenu.classList.remove("open");
          });
        });
      }

      // SCROLL TO TOP BUTTON
      const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      }
    });
  },
};

// Export the function to make it available globally
window.initProjectCardInteractions = initProjectCardInteractions;

export default projectsAnim;
